var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgLogoSmall = function SvgLogoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 243.07 145.34"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".LogoSmall_svg__cls-1{fill:currentColor}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LogoSmall_svg__Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LogoSmall_svg__Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "LogoSmall_svg__cls-1",
    d: "M162.1 30.91c-4 0-25.55-7.08-26.22-30.91h-.54c-1.2 24.76-22.19 30.91-26.22 30.91v.42c4 0 21.77 9.68 26.22 30.92h.54c4.45-21.24 22.2-30.92 26.22-30.92v-.42zM59.29 99.11L41.5 49.25a29.42 29.42 0 01-1.93-9c0-3.88 1.77-6.78 5.65-9.21v-.32H0V31c5.17 3.88 7.59 8.24 11 17.77l35.85 96.57h.81l13.87-39.93zM108.23 92.68L94.64 49.25a27.85 27.85 0 01-1.78-8.72c0-4 1.94-6.94 6.14-9.53v-.32H54.26V31c5.17 3.88 7.59 8.24 11 17.77l5.21 14.87 9.18 27 18.87 54.69h.81l13.44-38.16zM201.13 121.64l.07-91.09h-28.82v91.11c0 10.31-1.88 13.44-8.91 18v.31H210v-.31c-7-4.58-8.87-7.66-8.87-18.02zM243.07 65.23L239 29.16c-2.35 1.1-5.78 1.41-10.94 1.41H209V31c9 0 28.13 14.63 33.71 34.21z"
  })))));
};

export default SvgLogoSmall;